import * as ActionTypes from './actionTypes';
import {buildErrorMessage} from '../../common/util/errorUtils';
import apiActionCreator from '../../common/service/api/actionCreator';

export const fetchPriceFactorsGroups = () => apiActionCreator({
  'endpoint': '/price-factors/groups',
  'authenticated': true,
  'types': [
    ActionTypes.FETCH_PRICE_FACTORS_GROUPS_REQUEST,
    ActionTypes.FETCH_PRICE_FACTORS_GROUPS_SUCCESS,
    [
      ActionTypes.FETCH_PRICE_FACTORS_GROUPS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
